module.exports = __webpack_public_path__ + "static/paperwork-icon-mobile-d810db207ff15ce6dbaf1cb789284987.png";